/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint object-curly-newline: ["error", { "multiline": true }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import axios from 'axios';

// initial state
const state = {
  accounts: null,
  loaders: {
    accounts: false,
  },
  initializers: {
    accounts: false,
  },
};

// getters
const getters = {
  accounts: (state) => state.accounts,
  loaders: (state) => state.loaders,
  initializers: (state) => state.initializers,
};

// actions
const actions = {
  setProperty({ commit }, payload) {
    commit('SET_PROPERTY', payload);
  },

  getAccounts({ commit }) {
    commit('TOGGLE_LOADING', { key: 'accounts', value: true });
    return axios.get(`${CONFIG.get('BASE_URL')}/api/accounts/getAccounts/`)
      .then(({ data }) => {
        // Don't do this if not using large top banner
        commit('SET_PROPERTY', { key: 'accounts', value: data });
      })
      .catch(() => {})
      .finally(() => {
        commit('TOGGLE_LOADING', { key: 'accounts', value: false });
      });
  },

};

// mutations
const mutations = {
  SET_PROPERTY(state, payload) {
    state[payload.key] = payload.value;
  },
  TOGGLE_LOADING(state, payload) {
    state.loaders[payload.key] = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
